import { Pipe, PipeTransform } from '@angular/core';
import { ProductOfferingBenefit, ProductOfferingFeature } from '@mkp/shared/models';

/**
 * Flags are keyed by both the parent benefit and its checkmark child: the product table and the
 * comparison table receive the collapsed parent id, while the benefits modal resolves the raw
 * child id off the product.
 */
const BENEFIT_FLAGS: Partial<Record<ProductOfferingFeature, string>> = {
  [ProductOfferingBenefit.SwissCustomerSupport]: 'ch-square',
  [ProductOfferingBenefit.SwissCustomerSupportCheckmark]: 'ch-square',
};

@Pipe({ name: 'benefitFlag' })
export class BenefitFlagPipe implements PipeTransform {
  transform(feature: ProductOfferingFeature | undefined): string | undefined {
    return feature ? BENEFIT_FLAGS[feature] : undefined;
  }
}
